import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";

const { Text, Title } = Typography;
const { detailSalesTransactionItems, monthList, transactionTypeData } =
  staticConfig;

const DetailChequeWithdrawal = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [chequeDepositDetail, setChequeDepositDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCurrencies();
    getLocalCurrencies();
    getDetailById();
  }, []);

  function getCurrencies() {
    const url = `${apiConfig.GetCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempValue = objList;
        // setLocalCurrencyData(tempValue);
      }
    });
  }

  function getLocalCurrencies() {
    const url = `${apiConfig.GetLocalCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempEquityData = [];

        // objList.forEach((element) => {
        //   tempEquityData.push({
        //     value: element.id,
        //     label: element.name,
        //     code: element.glCode,
        //   });
        // });

        // setEquityData(tempEquityData);
      }
    });
  }

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.salesTransaction}/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setChequeDepositDetail(objDetail);
        setIsLoading(false);

        const transactionTypeLabel =
          (
            transactionTypeData.find(
              (type) => type.value === objDetail.transactionType
            ) || {}
          ).label || "Unknown";

        setInputField([
          {
            name: labelConfig.transactionDate,
            value: objDetail.transactionDate
              ? `${objDetail?.transactionDate[2]} ${
                  monthList[objDetail?.transactionDate[1] - 1]
                } ${objDetail?.transactionDate[0]}`
              : "-",
          },
          {
            name: labelConfig.amountACY,
            value: objDetail.accountCurrencyAmount,
          },
          {
            name: labelConfig.accountNo,
            value: objDetail.savingsAccountNo,
          },
          {
            name: labelConfig.chequeNo,
            value: "###################",
          },
          {
            name: labelConfig.transactionType,
            value: transactionTypeLabel,
          },
          {
            name: labelConfig.accountName,
            value: objDetail.customerName,
          },
          {
            name: labelConfig.accountCurrency,
            value: objDetail.accountCurrencyCode,
          },
          {
            name: labelConfig.transactionCCY,
            value: objDetail.transactionCurrencyCode,
          },
          {
            name: labelConfig.amountLCY,
            value: objDetail.localCurrencyAmount,
          },
          {
            name: labelConfig.amountTCY,
            value: objDetail.transactionAmount,
          },
          {
            name: labelConfig.charge,
            value: objDetail.charge ? objDetail.charge.name : "-",
          },
          {
            name: labelConfig.currencyRate,
            value: objDetail.exchangeRate,
          },
        ]);
        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailChequeWithdrawal}
        pageItems={staticConfig.detailChequeWithdrawalItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input disabled value={item.value} />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </Card>

        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailChequeWithdrawal);
